// components/QuizRenderer.js
import { useQuery } from '@apollo/client/react'
import { getContentfulClient } from '@/services/ApolloClient'
import { GetQuizQuery, Quiz } from '@/types/codegen-contentful'
import { useLocale } from '@/utils/LocaleUtil'
import { QuizDisplay } from './QuizDisplay'
import { getQuizQuery } from './QuizQueries'

interface QuizRendererProps {
  id: string
  preview?: boolean
}

export const QuizRenderer: React.FC<QuizRendererProps> = ({ id, preview = false }) => {
  const { locale } = useLocale()
  const client = getContentfulClient({ locale, preview })
  const { data, loading } = useQuery<GetQuizQuery>(getQuizQuery, {
    client,
    variables: { id, preview },
    errorPolicy: 'all',
  })

  return !loading && data?.quiz ? <QuizDisplay {...(data.quiz as Quiz)} /> : <div>Loading...</div>
}

export default QuizRenderer
